"use strict";

module.exports = /*@ngInject*/function ($window, PreferenceService, MOBILE, CONFIG) {
  var service = {
    // eslint-disable-next-line no-undef
    isCordovaEnabled: document.URL.indexOf('http://') === -1 && document.URL.indexOf('https://') === -1,
    changeChannel: function changeChannel(channel) {
      $window.localStorage.removeItem('access_token');
      PreferenceService.save('channel', channel);
    },
    getChannel: function getChannel() {
      return 'production';
    },
    getConfig: function getConfig() {
      if (!MOBILE) {
        return CONFIG;
      }
      var channel = PreferenceService.get().channel || service.getChannel();
      return CONFIG[channel];
    },
    getInternalCacheDirectory: function getInternalCacheDirectory() {
      return (
        // eslint-disable-next-line no-undef
        ionic.Platform.isIOS() ? cordova.file.tempDirectory : cordova.file.cacheDirectory
      );
    },
    getExternalCacheDirectory: function getExternalCacheDirectory() {
      return (
        // eslint-disable-next-line no-undef
        ionic.Platform.isIOS() ? cordova.file.tempDirectory : cordova.file.externalCacheDirectory
      );
    },
    // eslint-disable-next-line no-undef
    getDataDirectory: function getDataDirectory() {
      return cordova.file.dataDirectory;
    },
    getIosIndexedDbStorageDirectory: function getIosIndexedDbStorageDirectory() {
      return (// eslint-disable-next-line no-undef
        "".concat(cordova.file.applicationStorageDirectory, "/Library/WebKit/WebsiteData/IndexedDB/http_localhost_8080/LokiCatalog")
      );
    },
    getIosLokiCatalogDirectory: function getIosLokiCatalogDirectory() {
      return (// eslint-disable-next-line no-undef
        "".concat(cordova.file.applicationStorageDirectory, "/Library/WebKit/WebsiteData/IndexedDB/http_localhost_8080/")
      );
    }
  };
  return service;
};